// TR
export const locale = {
    common: {
        edit: "Düzenle",
        yes: "Evet",
        no: "Hayır",
        new: "Yeni",
        back: "Geri",
        language: "Dil",
        currency: "Para Birimi",
        cancel: "Vazgeç",
        send: "Gönder",
        confirm: "Devam Et",
        date: "Tarih",
        save: "Kaydet",
        report: "Bildir",
        active: "Aktif",
        passive: "Pasif",
        remove: "Sil",
        action: "İşlem",
        search: "Ara",
        close: "Kapat",
        preview: "Önizleme",
        today: "Bugün",
        weekly: "Haftalık",
        monthly: "Aylık",
        yearly: "Yıllık",
        viewAll: "Tümü Gör",
        notification: "Bildirim",
        download: "İndir",
        optional: "İsteğe Bağlı",
        permission: "Yetki",
        manager: "Yönetici",
        default: "Varsayılan",
        status: "Durum",
        sort: "Sırala",
        createdAt: "Oluşturulma Tarihi",
        chooseSelect: "Bir seçim yapın.",
        chooseDate: "Tarih seçin.",
        chooseTime: "Saat seçin.",
        chooseDateAndTime: "Tarih ve saat seçin.",
        selectGroup: "Lütfen bir grup seçin.",
        individual: "Bireysel",
        corporate: "Kurumsal",
        cash: "Peşin",
        system: "Sistem",
        export: "Dışa Aktar",
        overview: "Genel Bakış",
        settings: "Ayarlar",
        enable: "Etkinleştir",
        homePage: "Anasayfa",
        id: "ID",
        true: "Doğru",
        false: "Yanlış",
        hour: "Saat",
        minute: "Dakika",
        second: "Saniye",
        empty: "Boş",
        indefinite: "Süresiz",
        changePassword: "Şifre Değiştir",
        poster: "Öne Çıkan Görsel",
        you: "Sen",
        min: "Minimum",
        max: "Maksimum",
        start: "Başlangıç",
        end: "Bitiş",
        ip: "IP",
        userAgent: "Tarayıcı Bilgisi",
        selfLogin: "Hesaba Giriş Yap"
    },
    menu: {
        dashboard: "Gösterge Paneli",
        components: {
            title: "Komponentler",
            custom: {
                title: "Özel",
                table: "Tablo"
            },
            default: {
                title: "Default",
                alert: "Alert",


            },
            primevue: {
                title: "Prime vue",
                form: {
                    title: "Form",
                    editor: "Editor",
                    cascadeSelect: "CascadeSelect",
                    checkbox: "Checkbox",
                    colorPicker: "Color Picker",
                    datePicker: "Date Picker",
                    floatLabel: "FloatLabel",
                    iconField: "IconField",
                    iftaLabel: "IftaLabel",
                    inputGroup: "InputGroup",
                    inputMask: "InputMask",
                    inputNumber: "InputNumber",
                    inputOtp: "InputOtp",
                    inputText: "InputText",
                    keyFilter: "KeyFilter",
                    knob: "Knob",
                    listbox: "Listbox",
                    multiSelect: "MultiSelect",
                    password: "Password",
                    radioButton: "RadioButton",
                    rating: "Rating",
                    select: "Select",
                    selectButton: "SelectButton",
                    slider: "Slider",
                    textarea: "Textarea",
                    toggleButton: "ToggleButton",
                    toggleSwitch: "ToggleSwitch",
                    treeSelect: "TreeSelect",
                },
                button: {
                    title: "Butonlar",
                    button: "Button",
                    speedDial: "Speed Dial",
                    splitButton: "Split Button",
                },
                data: {
                    title: "Data",
                    dataTable: "DataTable",
                    orderList: "OrderList",
                    organizationChart: "Organization Chart",
                    paginator: "Paginator",
                    pickList: "PickList",
                    timeline: "Timeline",
                    tree: "Tree",
                    treeTable: "TreeTable",
                    virtualScroller: "Virtual Scroller",
                },
                panel: {
                    title: "Panel",
                    accordion: "Accordion",
                    card: "Card",
                    deferredContent: "Deferred Content",
                    divider: "Divider",
                    fieldset: "Fieldset",
                    panel: "Panel",
                    scrollPanel: "Scroll Panel",
                    splitter: "Splitter",
                    stepper: "Stepper",
                    tabs: "Tabs",
                    toolbar: "Toolbar",
                },
                overlay: {
                    title: "Overlay",
                    confirmDialog: "Confirm Dialog",
                    confirmPopup: "Confirm Popup",
                    dialog: "Dialog",
                    drawer: "Drawer",
                    dynamicDialog: "Dynamic Dialog",
                    popover: "Popover",
                    tooltip: "Tooltip",
                },
                fileUpload: "File Upload",
                chart: "Chart",
                message: {
                    title: "Messages",
                    message: "Message",
                    toast: "Toast",
                },
                media: {
                    title: "Media",
                    carousel: "Carousel",
                    galleria: "Galleria",
                    image: "Image",
                    imageCompare: "ImageCompare",
                },
                misc: {
                    title: "Misc",
                    animateOnScroll: "AnimateOnScroll",
                    avatar: "Avatar",
                    badge: "Badge",
                    chip: "Chip",
                    focusTrap: "Focus Trap",
                    inplace: "Inplace",
                    meterGroup: "MeterGroup",
                    progressBar: "ProgressBar",
                    progressSpinner: "ProgressSpinner",
                    scrollTop: "ScrollTop",
                    skeleton: "Skeleton",
                    tag: "Tag",
                    terminal: "Terminal",
                },
            },
        },
        pages: {
            title: "Sayfalar",
            library: "Kütüphane",
            store: "Mağaza",
            plan: "Plan Detayım",
            invoices: "Faturalar",
            settings: "Ayarlar",
            userManagement: {
                title: "Kullanıcılar",
                company: "Şirketler",
                user: "Kullanıcılar",
                group: "Kullanıcı Grupları",
            },
            developerOptions: {
                title: "Geliştirici Seçenekler",
                apiKeys: "Api Keyler",
            },
            modules: "Modüller",
            user: "Kullanıcılar",
            authentication: {
                title: "Doğrulama",
                signUp: {
                    title: "Kayıt Ol",
                    verify: "Kayıt Doğrulaması"
                },
                passwordReset: {
                    title: "Şifre Sıfırlama",
                    verify: "Şifre Yenileme",
                    confirmation: "Şifre Sıfırlama Onayı",
                },
                twoFactor: "Faktörlü Doğrulama",
                deActive: "Hesabınız Devre Dışı"
            },
            plans: "Planlar & Fiyatlandırma"
        },
        progress: {
            title: "Depolama Alanı",
            upgrade: "Yükselt",
            plan: "Paket",
            storage: "Depolama",
            traffic: "Trafik",
            usagePattern: "%s / %s GB",
            used: "kullanıldı",
        },
        developer: {
            title: "Yönetici İşlemleri",
            description: "Sistem yönetimi, kullanıcı ve operasyon süreçlerini merkezi olarak yönetin.",
            customerManagement: {
                title: "Müşteri Yönetimi",
                description: "Müşteri ve firma ilişkilerini yönetin, kayıtları düzenleyin ve süreçleri tek merkezden takip edin.",
                company: {
                    title: "Şirketler",
                    description: "Şirket bilgilerini yönetin, iş ortaklıklarını düzenleyin ve kurumsal yapıların takibini yapın.",
                },
                customer: {
                    title: "Müşteriler",
                    description: "Müşteri kayıtlarını görüntüleyin, düzenleyin ve müşteri ilişkilerini etkin şekilde yönetin.",
                },
            },
            cdnManagement: {
                title: "CDN Yönetimi",
                description: "CDN altyapınızı yönetin, içerik dağıtım ağlarını optimize edin ve performansı kontrol altında tutun.",

                cdnServer: {
                    title: "CDN Sunucuları",
                    description: "İçerik dağıtımını sağlayan CDN sunucularını görüntüleyin, ekleyin ve yapılandırmalarını yönetin.",
                },

                migrate: {
                    title: "CDN Migrate Görevleri",
                    description: "CDN üzerindeki içerikleri veya yapılandırmaları farklı sunuculara güvenli şekilde taşıma işlemlerini yönetin.",
                },
            },
            videoManagement: {
                title: "Video Yönetimi",
                description: "Video işlemlerini merkezi olarak yönetin ve tüm medya süreçlerini kontrol edin.",
                downloader: {
                    title: "Video İndirme Görevleri",
                    description: "Video kaynaklarını farklı platformlardan indirerek işlenmeye hazır hale getirin."
                },
                converter: {
                    title: "Video Dönüştürme Görevleri",
                    description: "Videoları farklı formatlara dönüştürerek sistem uyumluluğunu sağlayın."
                },
                migrate: {
                    title: "Video Migrate Görevleri",
                    description: "Videoları farklı sunucular veya CDN altyapıları arasında güvenli şekilde taşıyın."
                },
            },
            workerManagement: {
                title: "Görev Yöneticisi",
                description: "Sistem üzerindeki tüm arka plan görevlerini izleyin, yönetin ve performanslarını takip edin.",
                dashboard: {
                    title: "Genel Görünüm",
                    description: "Tüm iş süreçlerinin genel durumunu ve anlık sistem aktivitelerini görüntüleyin."
                },
            },
        }
    },
    messages: {
        warning: "Uyarı",
        success: "Başarılı",
        error: "Hata",
        sureAction: "Bu işlemi gerçekleştirmek istediğinizden emin misiniz? Lütfen dikkatli olun.",
        sureConfirm: "Bu işlemi onaylamak istediğinizden emin misiniz?",
        sureDelete: "Bu kaydı silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.",
        actionOk: "İşleminiz başarıyla tamamlandı.",
        deleteOk: "Silme işlemi başarıyla tamamlandı.",
        copyOk: "Kayıt başarıyla kopyalandı. Yeni kaydı kullanmaya başlayabilirsiniz.",
        copyLinkOk: "Link başarıyla kopyalandı.",
        copyLinkError: "Link kopyalanırken bir hata oluştu.",
        selectRow: "Lütfen işlem gerçekleştirmek için bir kayıt seçiniz.",
        wait: "İşleminiz devam ediyor, lütfen bekleyiniz...",
        loading: "Veriler yükleniyor. Lütfen sabırlı olunuz.",
        noResultFound: "Arama kriterlerinize uygun sonuç bulunamadı. Lütfen farklı kriterler kullanarak tekrar deneyiniz."
    },
    btn: {
        new: "Yeni",
        add: "Ekle",
        create: "Oluştur",
        copy: "Kopyala",
        edit: "Düzenle",
        customerDelete: "Müşteriyi Sil",
        delete: "Sil",
        yes: "Evet",
        no: "Hayır",
        cancel: "Vazgeç",
        close: "Kapat",
        refresh: "Yenile",
        update: "Güncelle",
        filter: "Filtrele",
        save: "Kaydet",
        saveAll: "Tümünü Kaydet",
        select: "Seç",
        selectFile: "Dosya Seç",
        upload: "Yükle",
        download: "İndir",
        action: "İşlem",
        previous: "Önceki",
        ensuing: "Sonraki",
        next: "İleri",
        back: "Geri",
        send: "Gönder",
        ok: "Tamam",
        clear: "Temizle",
        tryAgain: "Tekrar Dene",
        apply: "Uygula",
        reset: "Sıfırla",
        change: "Değiştir",
        check: "Kontrol Et",
        clone: "Klonla",
        selectedRowEvent: "Seçili Kayıt İşlemleri"
    },
    datepicker: {
        months: ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"],
        monthsShort: ["Oca", "Şub", "Mar", "Nis", "May", "Haz", "Tem", "Ağu", "Eyl", "Eki", "Kas", "Ara"],
        weekdays: ["Pt", "Sa", "Ça", "Pe", "Cu", "Ct", "Pz"],
    },
    validation: {
        required: "Bu alanı doldurmanız gerekmektedir.",
        email: "Lütfen geçerli bir e-posta adresi giriniz.",
        number: "Bu alana yalnızca sayı değeri girilmelidir.",
        confirmed: "Girdiğiniz bilgiler onay ile eşleşmiyor. Lütfen kontrol edin.",
        length: "Bu alanda en az 2 seçenek bulunmalıdır.",
        password: "Lütfen güçlü ve geçerli bir şifre giriniz.",
        passwordConfirmation: "Lütfen şifrenizi yeniden giriniz.",
        dontMatchPassword: "Girdiğiniz şifreler birbiriyle eşleşmiyor. Lütfen tekrar deneyiniz."
    },
    pages: {
        comingSoon: "Bu sayfa yakında tasarlanacak.",
        store: {
            title: "Mağaza",
            description: "Paketinize ek özellikler tanımlayın; depolama, trafik ve altyapı eklentilerini yönetin.",
            currentPlan: "Mevcut paketiniz",
            planDetail: "Plan Detayı",
            otherPlans: "Diğer Planlar",
            perMonth: "/ay",
            upgrade: "Yükselt",
            cart: "Sepet",
            cartTitle: "Sepetim",
            cartDescription: "Sepetinizdeki eklentileri gözden geçirin, adetleri düzenleyin ve satın alımı tamamlayın.",
            cartEmpty: "Sepetinizde henüz eklenti yok.",
            cartEmptyHint: "Mağazadan ihtiyacınız olan eklentileri sepetinize ekleyebilirsiniz.",
            cartNote: "Eklenti ücretleri mevcut paketinizin faturasına aylık olarak yansıtılır.",
            goToStore: "Mağazaya Git",
            summary: "Sipariş Özeti",
            perUnit: "adet",
            subtotal: "Ara Toplam",
            monthlyRecurring: "Aylık tekrarlayan",
            securePayment: "Ödemeleriniz güvenli altyapı üzerinden işlenir.",
            selectLocation: "Lokasyon Seçin",
            selectedLocations: "%s lokasyon seçildi",
            addToCart: "Sepete Ekle",
            addedToCart: "Eklenti sepetinize eklendi.",
            inCart: "Sepette",
            remove: "Kaldır",
            clearCart: "Sepeti Boşalt",
            continueShopping: "Alışverişe Devam Et",
            checkout: "Ödemeye Geç",
            checkoutSoon: "%s tutarındaki sepetiniz için ödeme adımı yakında eklenecek.",
            total: "Toplam",
            quantity: "Adet",
            quantityHint: "%s x %s kadar ek kapasite tanımlanacak.",
            active: "Aktif",
            multiple: "Çoklu alınabilir",
            locked: "Kilitli",
            unavailable: "Paketiniz Uygun Değil",
            allOwned: "Tümü Alındı",
            alreadyOwned: "Mevcut",
            ownedCount: "%s adet aktif",
            ownedLocations: "%s lokasyon aktif",
            requiresPlan: "Bu eklenti yalnızca %s paketinde kullanılabilir.",
            purchaseQueued: "%s tutarındaki eklenti talebiniz alındı.",
            category: {
                all: "Tümü",
                resource: "Kaynaklar",
                infrastructure: "Altyapı",
                service: "Hizmetler",
            },
            plans: {
                starter: "Starter",
                professional: "Professional",
                enterprise: "Enterprise",
            },
            locations: {
                tr: "Türkiye",
                de: "Almanya",
                uk: "İngiltere",
            },
            note: {
                multiple: "Bu eklentiden dilediğiniz kadar alabilirsiniz; kapasiteler toplanır.",
                upgrade: "Sahip olduğunuz lokasyonlar korunur, yenileri yükseltme olarak eklenir.",
                single: "Bu eklenti hesabınıza yalnızca bir kez tanımlanabilir.",
            },
            addons: {
                storage: {
                    title: "Ek Depolama",
                    description: "Paketinizin depolama alanını genişletin, videolarınız için daha fazla yer açın.",
                },
                traffic: {
                    title: "Ek Trafik",
                    description: "Aylık izlenme trafiğinizi artırın, yoğun dönemlerde kesinti yaşamayın.",
                },
                location: {
                    title: "Yayın Lokasyonları",
                    description: "İçeriklerinizi farklı ülkelerdeki sunuculardan yayınlayın, izleyiciye en yakın noktadan hizmet verin.",
                },
                drm: {
                    title: "DRM Koruması",
                    description: "İçeriklerinizi lisanslı şifreleme ile koruyun, izinsiz indirmeleri engelleyin.",
                },
                prioritySupport: {
                    title: "Öncelikli Destek",
                    description: "Taleplerinize öncelikli sırada yanıt verilir, teknik ekibe doğrudan erişirsiniz.",
                },
                customDomain: {
                    title: "Özel Alan Adı",
                    description: "Video bağlantılarınızı kendi alan adınız üzerinden sunun.",
                },
            },
        },
        plan: {
            title: "Plan Detayım",
            description: "Mevcut paketinizi, kullanım limitlerinizi ve yenileme bilgilerinizi görüntüleyin.",
            active: "Aktif",
            planTagline: "Ekibiniz için gelişmiş yayın ve depolama kapasitesi.",
            monthlyFee: "Aylık paket ücreti",
            renewsAt: "Yenileme tarihi",
            memberSince: "Üyelik başlangıcı",
            upgradePlan: "Planı Yükselt",
            comparePlans: "Planları Karşılaştır",
            cancelPlan: "Planı İptal Et",
            cancelSoon: "Plan iptal akışı yakında eklenecek.",
            cancelHint: "Planınızı iptal ederseniz dönem sonuna kadar kullanmaya devam edersiniz.",
            usage: {
                title: "Kullanım Durumu",
                storage: "Depolama",
                traffic: "Aylık Trafik",
                videos: "Video Sayısı",
                used: "kullanıldı",
                usedLabel: "Kullanılan",
                totalLabel: "Toplam",
                remainingLabel: "Kalan",
                remaining: "%s kaldı",
                unlimited: "Sınırsız",
                resetNote: "Dönem başında sıfırlanır",
            },
            features: {
                title: "Paketinize Dahil",
                storage: "32 GB depolama alanı",
                traffic: "Aylık 500 GB izlenme trafiği",
                hls: "Otomatik HLS dönüşümü ve kalite seçenekleri",
                players: "Sınırsız oynatıcı ve yerleştirme",
                analytics: "Detaylı izlenme raporları",
                support: "7/24 e-posta desteği",
                upload: "Video başına 5 GB yükleme hakkı",
                security: "Alan adı bazlı erişim kontrolü",
            },
            addons: {
                title: "Aktif Eklentiler",
                empty: "Henüz aktif bir eklentiniz yok.",
                goToStore: "Mağazaya Git",
                manage: "Eklentileri Yönet",
                included: "Pakete dahil",
                extra: "Ek eklenti",
                free: "Ücretsiz",
            },
            pendingInvoice: {
                title: "Ödemesi bekleyen faturanız var",
                description: "%s tutarındaki fatura %s tarihine kadar ödenmelidir.",
                action: "Faturayı Öde",
            },
            billing: {
                title: "Aylık Ödeme Özeti",
                planFee: "Paket ücreti",
                addonsFee: "Eklentiler",
                total: "Toplam",
                nextInvoice: "Sonraki fatura",
                viewInvoices: "Faturaları Görüntüle",
            },
        },
        invoices: {
            title: "Faturalar",
            description: "Geçmiş ödemelerinizi ve fatura belgelerinizi görüntüleyin, indirin.",
            detailTitle: "Fatura Detayı",
            detailDescription: "Fatura belgesini görüntüleyin, indirin veya ödemesini tamamlayın.",
            notFound: "Fatura bulunamadı.",
            backToList: "Faturalar",
            pendingAlert: "%s tutarında ödemesi bekleyen %s faturanız var.",
            payAll: "Tümünü Öde",
            cols: {
                number: "Fatura No",
                issuedAt: "Kesim Tarihi",
                dueAt: "Son Ödeme",
                paidAt: "Ödeme Tarihi",
                description: "Açıklama",
                total: "Tutar",
                status: "Durum",
            },
            status: {
                paid: "Ödendi",
                pending: "Bekliyor",
                overdue: "Gecikmiş",
                refunded: "İade Edildi",
                all: "Tümü",
            },
            actions: {
                pay: "Öde",
                view: "Görüntüle",
                download: "İndir",
                print: "Yazdır",
            },
            detail: {
                seller: "Satıcı",
                buyer: "Alıcı",
                ettn: "ETTN",
                issuedAt: "Kesim tarihi",
                dueAt: "Son ödeme tarihi",
                paidAt: "Ödeme tarihi",
                paymentMethod: "Ödeme yöntemi",
                items: "Fatura Kalemleri",
                item: "Kalem",
                quantity: "Adet",
                unitPrice: "Birim Fiyat",
                lineTotal: "Tutar",
                subtotal: "Ara toplam",
                tax: "KDV (%20)",
                total: "Genel Toplam",
                payNow: "Şimdi Öde",
                dueIn: "Son ödeme tarihine %s gün kaldı.",
                overdueBy: "Son ödeme tarihi %s gün önce doldu.",
            },
            payHint: "Ödeme altyapısı entegre edildiğinde bu işlem ödeme sayfasına yönlendirecek.",
        },
        payment: {
            title: "Ödeme",
            cartTitle: "Sepet Ödemesi",
            cartDescription: "Sepetinizdeki eklentilerin ödemesini tamamlayın.",
            invoiceTitle: "Fatura Ödemesi",
            invoiceDescription: "Seçtiğiniz faturaların ödemesini tamamlayın.",
            method: {
                title: "Kartlarım",
                addCard: "Yeni Kart Ekle",
                addCardHint: "Kart bilgilerinizi güvenle saklayın",
                noCard: "Ödeme yapmak için bir kart ekleyin.",
                remove: "Kartı sil",
                edit: "Kartı düzenle",
                expires: "Son kul.",
            },
            card: {
                title: "Yeni Kart Ekle",
                editTitle: "Kartı Düzenle",
                add: "Kartı Ekle",
                update: "Güncelle",
                numberLocked: "Kart numarası değiştirilemez.",
                holder: "Kart Üzerindeki İsim",
                holderPlaceholder: "Ad Soyad",
                number: "Kart Numarası",
                expiry: "Son Kullanma",
                cvv: "CVV",
                save: "Bu kartı sonraki ödemeler için kaydet",
                selectCard: "Bir kart seçin.",
                secure3d: "3D Secure ile öde",
            },
            summary: {
                title: "Ödeme Özeti",
                subtotal: "Ara toplam",
                tax: "KDV (%20)",
                total: "Ödenecek Tutar",
                monthly: "Aylık yinelenen",
                oneTime: "Tek seferlik",
            },
            terms: "Mesafeli satış sözleşmesini okudum ve onaylıyorum.",
            pay: "%s Öde",
            securePayment: "Ödemeniz 256-bit SSL ile korunur.",
            emptyCart: "Sepetiniz boş.",
            goToStore: "Mağazaya Git",
            noInvoice: "Ödenecek fatura bulunamadı.",
            goToInvoices: "Faturalara Git",
            invoiceLine: "%s · %s dönemi",
            successTitle: "Ödeme alındı",
            successCart: "Eklentileriniz hesabınıza tanımlandı.",
            successInvoice: "Faturalarınız ödendi olarak işaretlendi.",
            pendingIntegration: "Ödeme altyapısı entegre edildiğinde bu adımda sanal POS'a yönlendirileceksiniz.",
            validation: {
                holder: "Kart üzerindeki ismi girin.",
                number: "Geçerli bir kart numarası girin.",
                expiry: "Son kullanma tarihini AA/YY biçiminde girin.",
                cvv: "CVV kodunu girin.",
                terms: "Devam etmek için sözleşmeyi onaylayın.",
            },
        },
        settings: {
            title: "Ayarlar",
            description: "Hesap ve sistem tercihlerinizi yönetin.",
        },
        userManagement: {
            title: "Kullanıcılar",
            description: "Şirketleri, kullanıcıları ve kullanıcı gruplarını tek yerden yönetin.",
            company: {
                title: "Şirketler",
                description: "Şirket kayıtlarını görüntüleyin, düzenleyin ve yetkilendirin.",
            },
            user: {
                title: "Kullanıcılar",
                description: "Kullanıcı hesaplarını oluşturun, düzenleyin ve erişimlerini yönetin.",
            },
            group: {
                title: "Kullanıcı Grupları",
                description: "Grupları ve gruplara tanımlı yetkileri yönetin.",
            },
        },
        developerOptions: {
            title: "Geliştirici Seçenekler",
            description: "Entegrasyon araçlarını ve geliştirici ayarlarını yönetin.",
            apiKeys: {
                title: "Api Keyler",
                description: "API anahtarlarınızı oluşturun, yetkilendirin ve yönetin.",
            },
        },
        login: {
            title: "Giriş Yap",
            description: "Sınırsız erişim elde edin ve para kazanın",
            back: {
                title: "Henüz üye olmadın mı?",
                buttonTitle: "Üye Ol"
            },
            cols: {
                customerID: "Müşteri Numarası",
                email: "E - Posta",
                password: "Şifre",
                confirmation: "Giriş yapmanız halinde <a href='https://virtara.tr/kullanim-sartlari-ve-kosullari' target='_blank' class='kt-link text-xs inline'>Kullanım Şartlarını ve Koşullarını</a> kabul etmiş olursunuz."
            },
            successLogin: "Başarıyla giriş yaptınız. Hoş geldiniz!",
            btnText: "Giriş Yap",
            responseMessage: {
                title: "Hata Oluştu",
                invalid_credentials: "E-Posta veya Şifre hatalı. Lütfen geçerli kimlik bilgileri ile tekrar deneyiniz."
            },
        },
        auth: {
            banner: {
                title: "ViPanel",
                content: "Yönetim paneli arayüzüne güvenli ve verimli kullanıcı erişimi sağlayan güçlü bir kimlik doğrulama geçidi.",
                theme: {
                    light: "Aydınlık Mod",
                    dark: "Koyu Mod",
                    system: "Otomatik"
                }
            },
            register: {
                title: "Hesap Oluştur",
                description: "Sınırsız erişim elde edin ve para kazanın",
                login: {
                    title: "Zaten üye misiniz?",
                    signIn: "Giriş Yapın"
                },
                cols: {
                    firstname: "Ad",
                    lastname: "Soyad",
                    identificationNumber: "Kimlik No",
                    email: "E-Posta",
                    mobilePhone: "Telefon",
                    birthDate: "Doğum Tarihi",
                    password: "Şifre",
                    passwordConfirmation: "Şifre Tekrar",
                    confirmation: "Giriş yapmanız halinde <a href='https://virtara.tr/kullanim-sartlari-ve-kosullari' target='_blank' class='kt-link text-xs inline'>Kullanım Şartlarını ve Koşullarını</a> kabul etmiş olursunuz."
                },
                sureRegister: {
                    title: "Kaydı tamamlamak istiyor musunuz?",
                    description: "Kayıt olduktan sonra <b>e-posta</b> ve <b>telefon numarasını</b> değiştiremezsiniz, bu yüzden doğru bilgileri girdiğinizden emin olun."
                },
                responseMessage: {
                    success: "Başarılı şekilde kaydınızı tamamladınız! Hoş geldiniz!"
                },
                verify: {
                    title: "E-posta adresinizi doğrulayın",
                    description: "E-posta almadınız mı? <a href='/auth/sign-up' class='kt-link kt-link-underlined kt-link-dashed'>Tekrar Dene</a>",
                    buttonTitle: "Şimdilik Atla"
                }
            },
            passwordReset: {
                title: "Şifrenizi mi unuttunuz?",
                description: "Şifrenizi sıfırlamak için E-posta adresinizi girin.",
                back: {
                    title: "Zaten üye misiniz?",
                    buttonTitle: "Giriş Yap"
                },
                cols: {
                    customerID: "Müşteri Numarası",
                    email: "E-Posta",
                    confirmation: "Giriş yapmanız halinde <a href='https://virtara.tr/kullanim-sartlari-ve-kosullari' target='_blank' class='kt-link text-xs inline'>Kullanım Şartlarını ve Koşullarını</a> kabul etmiş olursunuz."
                },
                responseMessage: {
                    success: "Şifre sıfırlama talimatları e-posta adresinize gönderildi.",
                    password_reset_rate_error: "Şifre sıfırlama talebinizi son talep zamanından 120 saniye sonra yapabilirsiniz."
                },
                verify: {
                    title: "Şifre Yenile",
                    description: "Yeni şifrenizi onay kodu ile birlikte girin.",
                    back: {
                        title: "Zaten üye misiniz?",
                        buttonTitle: "Giriş Yap"
                    },
                    cols: {
                        email: "E-Posta",
                        password: "Şifre",
                        passwordConfirmation: "Şifre Tekrar",
                        code: "Onay Kodu"
                    },
                    responseMessage: {
                        success: "Şifreniz başarıyla sıfırlandı.",
                        invalid_token: "Bu bağlantı geçerliliğini yitirmiş veya daha önce kullanılmış. Lütfen yeni bir bağlantı talep ediniz."
                    }
                },
                confirmation: {
                    title: "Şifreniz başarıyla sıfırlandı.",
                    description: "Yaratıcı olmak için harika bir fırsat <a href='#' class='kt-link kt-link-underlined kt-link-dashed'>max{'@'}keenthemes.com</a> <br>okuyuculara bir fikir veriyor"
                }
            },
            twoFactor: {
                title: "İki Faktörlü Doğrulama",
                description: "Gönderdiğimiz doğrulama kodunu girin",
                phoneFormat: "******7859",
                cols: {
                    code: "6 haneli güvenlik kodunu girin"
                }
            },
            deActive: {
                title: "Hesabınız devre dışı bırakıldı",
                description: "Harika fırsatlar elde edebilirsiniz. Daha fazla bilgi için lütfen bizimle iletişime geçiniz.",
                btnText: "Ana Sayfaya Dön"
            },
        },
        account: {
            overview: {
                title: "Profil Detayları",
                cols: {
                    name: "Ad",
                    surname: "Soyad",
                    email: "E-Posta",
                    phone: "Telefon"
                }
            },
            settings: {
                signInMethod: {
                    title: "Giriş Yöntemi",
                    emailAddress: "E-Posta Adresi",
                    password: {
                        title: "Şifre",
                        cols: {
                            currentPassword: "Mevcut Şifre",
                            password: "Yeni Şifre",
                            passwordConfirmation: "Yeni Şifre Tekrar"
                        },
                        changePassword: "Şifre Değiştir",
                        updatePassword: "Şifreyi Güncelle"
                    }
                }
            }
        },
        dashboard: {},
        video: {
            detail: {
                title: "Video Detayı",
                description: "Video bilgilerini görüntüleyin, düzenleyin ve yayın kaynaklarını yönetin.",
                deleteContent: "İçeriği Sil",
                tab: {
                    general: "Detay",
                    image: "Resimler",
                    video: "Video"
                },
                cols: {
                    title: "Başlık",
                    group: "Video Grubu"
                },
                options: {
                    title: "İşlem Parametreleri",
                    type: {
                        convert_mp4: "MP4 haricindekileri dönüştür",
                        convert_unsupported: "Desteklenmeyenleri MP4'e çevir",
                        convert_hls: "HLS için export oluştur"
                    }
                },
                processState: {
                    title: "İşlem Durumu",
                    type: {
                        CONVERT_HLS: "HLS Dönüşümü",
                        CONVERT_COMPRESSION: "Video Sıkıştırma"
                    }
                },
                extras: {
                    title: "Diğer Bilgiler",
                    sizeChanged: {
                        old: "Orjinal (%s)"
                    }
                },
                copyUrl: {
                    title: "Direk Erişim URL",
                    copied: "Kopyalandı!"
                },
                stream: {
                    title: "Desteklenen Yayınlar",
                    cols: {
                        type: "Tip",
                        size: "Boyut",
                        url: "URL"
                    }
                },
                videoImage: {
                    title: "Video Resimleri",
                    noData: "Bu video için üretilmiş resim bulunmuyor."
                },
                videoTab: {
                    original: "Orijinal",
                    hls: "HLS"
                },
                warning: {
                    videoCompress: {
                        text1: "Video Sıkıştırma işlemi devam ediyor. Bu süreç tamamlandıktan sonra görüntülenen video bilgileri (direk erişim url, thumbnail vb.) değişiklik gösterebilir. Video sıkıştırma işlemi tamamlandıktan sonra nihai bilgiler gösterilecektir.",
                        text2: "Video sıkıştırma işlemi sunucu yoğunluğu, video renk kodlaması vb. gibi durumlara bağlı olarak birkaç saat kadar sürebilir.",
                        videoLink: "Video sıkıştırma işlemi yapıldıktan sonra URL gösterilecektir."
                    }
                }
            }
        },
        library: {
            title: "Kütüphane",
            description: "Dijital içeriklerinizi yükleyin, organize edin ve kolayca yönetin.",
            mainDirectory: "Ana Klasör",
            noData: "Klasörde listelenecek bir veri bulunamadı.",
            downloadNoVideo: "Seçimde indirilebilir video bulunmuyor.",
            downloadStarted: "İndirme hazırlanıyor, dosya boyutuna göre biraz sürebilir.",
            trash: {
                title: "Çöp Kutusu",
                description: "Silinen içerikleri görüntüleyin, kurtarın veya kalıcı olarak silin.",
                warningTitle: "Uyarı",
                warningText: "Silinen içerikler yanlışlıkla yapılan hataları önlemek amacıyla bu sayfada gösterilir ve 7 gün boyunca saklanır. Süre sonunda kalıcı olarak silinir. İçeriği kurtarmak veya kalıcı olarak silmek için aşağıdaki butonları kullanabilirsiniz.",
                noData: "Çöp kutusu boş.",
                remainingPattern: "%s gün",
                confirmRemoveForever: "Seçili içerik(ler) kalıcı olarak silinecek ve geri alınamaz. Devam edilsin mi?",
                cols: {
                    title: "Başlık",
                    detail: "Detay",
                    deletedAt: "Silinme Tarihi",
                    remaining: "Kalan Süre",
                },
                action: {
                    recover: "Kurtar",
                    removeForever: "Kalıcı Olarak Sil",
                },
            },
            type: {
                directory: "Klasör",
                video: "Video",
                void: "Ses",
                image: "Fotoğraf"
            },
            cols: {
                id: "ID",
                title: "Başlık",
                type: "Tür",
                date: "Tarih",
                size: "Boyut",
                sizePattern: "%s Klasör",
                actions: "İşlemler",
            },
            action: {
                sort: "Sırala",
                filter: "Filitre",
                addFolder: "Klasör Ekle",
                updateFolder: "Klasör Düzenle",
                addVideo: "Video Ekle",
                copyLink: "Link Kopyala",
                addFavorite: "Favorilere Ekle",
                removeFavorite: "Favorilerden Çıkart",
                remove: "Çöp Sepetine Taşı",
                move: "Şuraya Taşı",
                clearSelection: "Seçimi Kaldır",
                soundOn: "Sesi Aç",
                soundOff: "Sesi Kapat",
                newFolderName: "Yeniden Adlandır",
                download: "İndir",
                openVideo: "Video Detayı",
                openDirectory: "Klasörü Aç",
            },
            selectionChip: "%s öğe seçildi",
            directory: {
                save: {
                    title: "Klasör Ekle",
                    cols: {
                        title: "Klasör Adı",
                        defaultTitle: "Yeni Klasör",
                    }
                },
                move: {
                    title: "Klasörü Taşı",
                    cols: {
                        title: "Klasör Seç",
                    }
                }
            },
            video: {
                save: {
                    title: "Video Ekle",
                    cols: {
                        video: "Video",
                        title: "Video Başlığı",
                        patternVideoTitle: "%s. Video Başlığı",
                        group: "Video Grubu",
                        convert_hls: "HLS için export oluştur.",
                        convert_unsupported: "Desteklenmeyen videoları otomatik olarak uyumlu formata dönüştür",
                    }
                },
                move: {
                    title: "Video Taşı",
                    cols: {
                        title: "Video Seç",
                    }
                }
            },
            move: {
                title: "Şuraya Taşı",
                cols: {
                    parentId: "Klasör Seç"
                }
            },
        },
        plans: {
            title: "Planlar & Fiyatlandırma",
            description: "İhtiyacınıza en uygun planı seçin, hemen kullanmaya başlayın. Tüm planlarımız esnek ve ölçeklenebilir yapıdadır.",
        },
        developer: {
            customerManagement: {
                company: {
                    title: "Firmalar",
                    description: "Firma bilgilerinizi organize edin, iş ortaklıklarınızı tek bir yerden yönetin.",
                    add: "Firma Ekle",
                    update: "Firma Düzenle",
                    cols: {
                        name: "Firma Adı",
                        usersCount: "Kayıtlı Personel",
                    }
                },
                customer: {
                    title: "Müşteriler",
                    description: "Müşteri kayıtlarınızı görüntüleyin, düzenleyin ve ilişkilerinizi kolayca yönetin.",
                    add: "Müşteri Ekle",
                    update: "Müşteri Düzenle",
                    cols: {
                        firstname: "Adı",
                        lastname: "Soyadı",
                        email: "E-Posta Adresi",
                        company: "Şirket",
                        group: "Group",
                        active: "Durum",
                        password: "Şifre",
                    },
                    save: {
                        add: "Müşteri Ekle",
                        update: "Müşteri Detayı",
                        information: "Müşteri Bilgileri",
                        passwordChange: "Şifre Değiştir",
                        is_editable: "Müşteri Düzenlenebilir",
                        is_deletable: "Müşteri Silinebilir",
                        tabs: {
                            detail: "Detay",
                            storage: "Depolama",
                        },
                        cols: {
                        }
                    },
                    changePassword: {
                        title: "Şifre Değiştir",
                        description: "Hesap güvenliğiniz için güçlü ve benzersiz bir şifre belirleyin. Şifrenizi düzenli olarak güncellemeniz önerilir.",
                        btn: "Şifreyi Değiştir",

                    }
                }
            },
            videoManagement: {
                migrate: {
                    cols: {
                        total: "Toplam",
                        inProcess: "İşlemde",
                        pending: "Bekleyen",
                        completed: "Tamamlanan",
                        progress: "İlerleme",
                        createdAt: "Oluşturulma Tarihi",
                    }
                },
            },
        }
    },
    filters: {
        invoice: {
            number: "Fatura No",
            status: "Durum",
            dateRange: "Tarih Aralığı",
            startDate: "Başlangıç",
            endDate: "Bitiş",
        },
        title: "Filtre Seçenekleri",
        user: {
            id: "Kullanıcı ID"
        },
        library: {
            id: "ID (Video ya da Klasör)",
            title: "Başlık",
        },
    },
    components: {
        libraryVideo: {
            uploadTitle: "Videoları sürükleyin veya tıklayarak seçin"
        }
    },
    customTable: {
        noData: "Listelenecek veri bulunamadı.",
        showingPageInformationPattern: "%s kayıttan, %d ile %d arası gösteriliyor"
    },
    userMenu: {
        language: "Dil",
        account: "Hesabım",
        security: "Güvenlik",
        userRoles: "Üyeler & Roler",
        integration: "Entegrasyonlar",
        darkMode: "Koyu Mod",
        signOut: "Çıkış Yap"
    },
    footer: {
        copyrightText: "Virtara Group Bilişim Teknolojileri. Tüm hakları saklıdır."
    },
    endpointActions: {
        get: "Görüntüleme",
        post: "Ekleme",
        put: "Güncelleme",
        delete: "Silme"
    },
    responseErrors: {
        record_not_found: "Kayıt bulunamadı. Silinmiş veya başka bir yere taşınmış olabilir. Lütfen farklı bir kayıt arayınız.",
        method_not_found: "İşlem bulunamadı. Silinmiş veya başka bir yere taşınmış olabilir. Lütfen tekrar deneyin.",
        invalid_file_type: "Geçersiz dosya türü seçildi. Lütfen uygun bir dosya türü kullanınız.",
        current_password_invalid: "Mevcut şifre hatalı. Lütfen doğru şifreyi girip tekrar deneyiniz.",
        this_group_not_usable: "Bu grup şu an kullanılamaz. Lütfen farklı bir grup seçin.",
        invalid_identification_number: "Geçersiz kimlik numarası girildi. Lütfen geçerli bir kimlik numarası kullanınız.",
        validate_error: "Doğrulama hatası oluştu. Lütfen bilgilerinizi kontrol ederek tekrar deneyiniz.",
        provider_handler_not_found_by_code: "Belirtilen koda göre sağlayıcı bulunamadı. Lütfen geçerli bir kod giriniz.",
        video_id_invalid: "Geçersiz video kimliği girdiniz. Lütfen geçerli bir kimlik giriniz.",
        invalid_customer_id: "Müşteri numarası hatalı. Lütfen geçerli bir müşteri numarası ile tekrar deneyiniz.",
        login_description: "Lütfen tarafınıza iletilen yetkili giriş bilgilerini kullanarak oturum açın.",
        login_error: "Giriş bilgilerinizi kontrol edin.",
        invalid_credentials: "E-Posta veya Şifre hatalı. Lütfen geçerli kimlik bilgileri ile tekrar deneyiniz."
    }
};
